'use client';

import type { HTMLAttributes, ReactNode } from 'react';
import React from 'react';
import type { CSSProperties } from 'styled-components';

import { Flex, Spacing } from '@zoomit/primitives';

export type TextIconProps = {
  gap?: keyof typeof Spacing;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  direction?: CSSProperties['flexDirection'];
};

type Props = HTMLAttributes<HTMLDivElement> & TextIconProps;

export const TextIcon = (props: Props) => {
  const { gap = 'x', leftIcon, rightIcon, direction = 'row', children, ...rest } = props;

  return (
    <Flex
      justifyContent="center"
      flexWrap="nowrap"
      alignItems="center"
      gap={Spacing[gap]}
      flexDirection={direction}
      {...rest}
    >
      {rightIcon}
      {children}
      {leftIcon}
    </Flex>
  );
};
